import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { SyncLoader } from 'halogenium';

import { getEvents } from 'actions/siteEventActions';
import * as bookingActions from 'actions/bookingsActions';

import ShowingSelector from 'components/tenant_app/components/tenant_dashboard/todos/ShowingSelector';

import { CSSTransitionGroup } from 'react-transition-group';

import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import FlatButton from '@material-ui/core/Button';
import CollapsibleRight from 'components/shared/CollapsibleRight';
import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import * as format from 'helpers/Formatter';
import { deepDiver } from 'helpers/utilities';
import { getTranslatedString } from 'helpers/i18n';

let ViewEventDialog = class extends Component {
  render() {
    const { eventDetails, style } = this.props;
    return (
      <div>
        <div className="row" style={style.info_header}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center', textTransform: 'uppercase !important' }}>
              {getTranslatedString('landlordPortal.viewEventDialog.detailsUpcase')}{' '}
              <TenantResidentVerbiageHelper uppercase />{' '}
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            <h5 style={{ marginBottom: '2px' }}>
              {getTranslatedString('landlordPortal.viewEventDialog.propertyName')}
            </h5>
            <p>{eventDetails.tenant_details.property}</p>
          </div>
          <div className="col-sm-6">
            <h5 style={{ marginBottom: '2px' }}>
              {getTranslatedString('landlordPortal.viewEventDialog.unitNumber')}
            </h5>
            <p>{eventDetails.tenant_details.unit_number || 'n/a'}</p>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            <h5 style={{ marginBottom: '2px' }}>
              {getTranslatedString('landlordPortal.viewEventDialog.tenantName')}
            </h5>
            <p>{eventDetails.tenant_details.tenant_full_name}</p>
          </div>
          <div className="col-sm-6">
            <h5 style={{ marginBottom: '2px' }}>
              {getTranslatedString('landlordPortal.viewEventDialog.tenantPhoneNumber')}
            </h5>
            <p>{format.formatPhone(eventDetails.tenant_details.tenant_phone_number)}</p>
          </div>
        </div>
      </div>
    );
  }
};

let RSVPDetails = class extends Component {
  render() {
    const { eventDetails, style } = this.props;
    return (
      <div>
        <div className="row" style={style.info_header}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {' '}
              {getTranslatedString('landlordPortal.viewEventDialog.rsvpDetailsUpcase')}{' '}
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            <h5 style={{ marginBottom: '2px' }}>
              {getTranslatedString('landlordPortal.viewEventDialog.propertyName')}
            </h5>
            <p>{eventDetails.rsvp_details.property}</p>
          </div>
          <div className="col-sm-6">
            <h5 style={{ marginBottom: '2px' }}>
              {getTranslatedString('landlordPortal.viewEventDialog.totalInvitedGuests')}
            </h5>
            <p>{eventDetails.rsvp_details.total_invited}</p>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ marginBottom: '10px' }}>
            <CollapsibleRight
              headerWidth={180}
              header={
                <div className="row" style={{ textAlign: 'center' }}>
                  <button
                    type="button"
                    className="link-button"
                    style={{ fontSize: '14px', fontFamily: '"Circular", sans-serif' }}
                  >
                    {' '}
                    {getTranslatedString('landlordPortal.viewEventDialog.clickToViewAllGuests')} (
                    {eventDetails.rsvp_details.number_of_confirmed}){' '}
                  </button>
                </div>
              }
            >
              <div className="row" style={{ marginTop: '8px' }}>
                <div className="col-xs-2">
                  <h5>{getTranslatedString('landlordPortal.viewEventDialog.RSVPDate')}</h5>
                </div>
                <div className="col-xs-4">
                  <h5>{getTranslatedString('landlordPortal.viewEventDialog.tenantName')}</h5>
                </div>
                <div className="col-xs-2">
                  <h5>{getTranslatedString('landlordPortal.addEventDialog.unit')}</h5>
                </div>
                <div className="col-xs-4">
                  <h5>{getTranslatedString('landlordPortal.viewEventDialog.propertyName')}</h5>
                </div>
              </div>

              {eventDetails.rsvp_details.confirmed_guests.map((rsvped_guest, index) => (
                <Fragment>
                  <div className="row" key={index}>
                    <div className="col-xs-2">
                      <h5 style={{ fontFamily: 'Circular', margin: '2px 0' }}>
                        {format.toFriendlyDateTimeString(rsvped_guest.rsvp_date)}
                      </h5>
                    </div>
                    <div className="col-xs-4">
                      <h5 style={{ fontFamily: 'Circular', margin: '2px 0' }}>
                        {rsvped_guest.name}
                      </h5>
                    </div>
                    <div className="col-xs-2">
                      <h5 style={{ fontFamily: 'Circular', margin: '2px 0' }}>
                        {rsvped_guest.unit_number}
                      </h5>
                    </div>
                    <div className="col-xs-4">
                      <h5 style={{ fontFamily: 'Circular', margin: '2px 0' }}>
                        {rsvped_guest.property}
                      </h5>
                    </div>
                  </div>
                  <hr />
                </Fragment>
              ))}
            </CollapsibleRight>
          </div>
        </div>
      </div>
    );
  }
};

let EventDetails = class extends Component {
  state = {
    originalNotes: this.props.eventDetails.notes,
    amenityNotes: this.props.eventDetails.notes,
  };

  render() {
    const style = {
      info_header: {
        margin: '5px -20px 10px -20px',
        backgroundColor: '#f1f1f1',
        padding: '5px 10px',
        fontSize: '14px',
        fontWeight: '800',
      },
    };

    const { eventDetails } = this.props;
    return (
      <div className="row">
        {eventDetails.tenant_details && (
          <ViewEventDialog eventDetails={this.props.eventDetails} style={style} />
        )}

        {eventDetails.rsvp_details && (
          <RSVPDetails eventDetails={this.props.eventDetails} style={style} />
        )}

        <div className="row" style={style.info_header}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {' '}
              {getTranslatedString('landlordPortal.viewEventDialog.eventDetailsUpcase')}{' '}
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <h5 style={{ marginBottom: '2px' }}>
              {getTranslatedString('landlordPortal.viewEventDialog.eventDescription')}
            </h5>
            <p>{eventDetails.description}</p>
          </div>
        </div>

        {eventDetails.link && (
          <div className="row">
            <div className="col-xs-12">
              <h5 style={{ marginBottom: '2px' }}>
                {getTranslatedString('landlordPortal.viewEventDialog.eventLink')}
              </h5>
              <a href={eventDetails.link} target="_blank" rel="noopener noreferrer">
                {eventDetails.link_alt ? eventDetails.link_alt : eventDetails.name}
              </a>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-sm-6">
            <h5 style={{ marginBottom: '2px' }}>
              {getTranslatedString('landlordPortal.viewEventDialog.startDate')}
            </h5>
            <p>
              {format.toFriendlyDateTimeString(
                eventDetails.start_date || eventDetails.actionable_date,
                { language: this.props.languageCode }
              )}
            </p>
          </div>
          <div className="col-sm-6">
            <h5 style={{ marginBottom: '2px' }}>
              {getTranslatedString('landlordPortal.viewEventDialog.endDate')}
            </h5>
            <p>
              {format.toFriendlyDateTimeString(
                eventDetails.end_date || eventDetails.actionable_end_date,
                { language: this.props.languageCode }
              )}
            </p>
          </div>
        </div>
        {this.renderAmenityNotes()}
      </div>
    );
  }

  renderAmenityNotes = () => {
    if (!this.props.isAmenityBooking) return;
    return (
      <Fragment>
        <div className="row">
          <div className="col-xs-12">
            <h5 style={{ marginBottom: '2px' }}>
              {getTranslatedString('landlordPortal.viewEventDialog.internalNotes')}
            </h5>
            <TextField
              name="notes"
              type="text"
              onChange={e => this.setState({ amenityNotes: e.target.value })}
              value={this.state.amenityNotes}
              multiline
            />
          </div>
        </div>
        <CSSTransitionGroup
          transitionName="shrink_buttons"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={400}
        >
          {this.renderAmenityNotesButton()}
        </CSSTransitionGroup>
      </Fragment>
    );
  };

  renderAmenityNotesButton = () => {
    const isDirty = this.state.originalNotes !== this.state.amenityNotes;
    if (!isDirty) return;

    return (
      <div className="row" style={{ textAlign: 'center' }}>
        <FlatButton
          onClick={() => this.props.updateAmenity(this.state.amenityNotes)}
          style={{ color: AccentColor() }}
        >
          {getTranslatedString('landlordPortal.viewEventDialog.saveNoteUpcase')}
        </FlatButton>
      </div>
    );
  };
};

EventDetails = connect(store => ({
  languageCode: store.locale.currentLanguage,
}))(EventDetails);

export default withMobileDialog()(
  connect(null, { ...bookingActions, getEvents })(
    class LandlordSiteEvents extends Component {
      constructor(props) {
        super(props);
        this.state = {
          showEditAmenityBooking: false,
        };
      }

      toggleDialog = () => {
        this.props.toggleDialog();
        this.setState({ showEditAmenityBooking: false });
      };

      editEvent = isAmenity => {
        if (!isAmenity) {
          return this.props.editEvent(this.props.eventDetails);
        }

        this.setState(prevState => ({
          showEditAmenityBooking: !prevState.showEditAmenityBooking,
        }));
      };

      submitForm = vars => {
        this.props.setToIsLoading();
        this.props.removePreviousSearchResults();
        this.props.showAvailableAmenityBookings(
          this.props.eventDetails.id,
          vars.time,
          vars.date,
          vars.requested_booking_length
        );
      };

      onComplete = () => {
        this.toggleDialog();
        const propertyID = deepDiver(this.props.eventDetails, 'property.value');
        if (!propertyID) return;
        this.props.getEvents(propertyID);
      };

      updateAmenity = amenityNotes => {
        this.props.editAmenityBookingNotes(this.props.eventDetails.booking_id, amenityNotes);
      };

      render() {
        const { fullScreen } = this.props;
        const isAmenityBooking = this.props.eventDetails.event_type === 'AmenityBooking';
        const headerVerbiage = isAmenityBooking
          ? ` ${getTranslatedString('landlordPortal.viewEventDialog.booking')}`
          : '';
        const dialogHeader = this.props.eventDetails.name
          ? this.props.eventDetails.name + headerVerbiage
          : getTranslatedString('landlordPortal.viewEventDialog.eventDetails');
        const amenityExpandAnimation = isAmenityBooking
          ? 'show_amenity_notes'
          : 'event_details_form';

        return (
          <div>
            <Dialog
              fullScreen={fullScreen}
              open={this.props.isOpen}
              onClose={this.toggleDialog}
              aria-labelledby="add-new-event"
              classes={{
                paper: 'form-dialog',
              }}
            >
              <DialogTitle id="add-new-survey">
                <h3 style={{ textAlign: 'center', margin: 0 }}>{dialogHeader}</h3>
              </DialogTitle>
              <DialogContent style={{ padding: '0 9px 24px' }}>
                <CSSTransitionGroup
                  transitionName="events_loading"
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={400}
                >
                  {!this.props.eventDetails.name && (
                    <div style={{ textAlign: 'center' }}>
                      <SyncLoader
                        color={AccentColor()}
                        size="16px"
                        margin="auto"
                        style={{ paddingTop: '10px' }}
                      />
                    </div>
                  )}
                </CSSTransitionGroup>
                <CSSTransitionGroup
                  transitionName={amenityExpandAnimation}
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={500}
                >
                  {this.props.eventDetails.name && (
                    <EventDetails
                      eventDetails={this.props.eventDetails}
                      isAmenityBooking={isAmenityBooking}
                      updateAmenity={this.updateAmenity}
                    />
                  )}
                </CSSTransitionGroup>
                <CSSTransitionGroup
                  transitionName="show_booking_view"
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={500}
                >
                  {this.renderEditAmenityBooking()}
                </CSSTransitionGroup>
              </DialogContent>
              <DialogActions style={{ display: 'block' }}>
                <FlatButton
                  onClick={this.toggleDialog}
                  id="close-button"
                  style={{ color: AccentColor() }}
                >
                  {getTranslatedString('landlordPortal.viewEventDialog.closeUpcase')}
                </FlatButton>
                <FlatButton
                  variant="raised"
                  onClick={this.props.deleteEvent}
                  disabled={this.props.submitting}
                  id="submit-button"
                  style={{
                    color: 'white',
                    backgroundColor: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
                  }}
                >
                  {getTranslatedString('landlordPortal.viewEventDialog.cancelEventUpcase')}
                </FlatButton>
                <FlatButton
                  onClick={() => this.editEvent(isAmenityBooking)}
                  disabled={this.props.submitting}
                  id="submit-button"
                  style={{
                    color: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
                  }}
                >
                  {getTranslatedString('landlordPortal.viewEventDialog.editUpcase')}
                </FlatButton>
              </DialogActions>
            </Dialog>
          </div>
        );
      }

      renderEditAmenityBooking = () => {
        if (!this.state.showEditAmenityBooking) return;

        return (
          <ShowingSelector
            amenityBookingDetails={this.props.eventDetails}
            submitForm={this.submitForm}
            fullScreen={this.props.fullScreen}
            onComplete={this.onComplete}
          />
        );
      };
    }
  )
);
